import { displayLinkedPartnerCustomer } from '../../../../widgets/partner-customer-widget';
import { IAccessList } from '../../../../../models/user.interface';

/**
 * Function that gets the selected item from the available list
 * 
 * @param {HTMLElement} avalContainer the HTML container for the available list
 * @param {HTMLElement} resultsContainer the HTML container for the selected items
 */
export const getSelectedItem = (avalContainer: HTMLElement, resultsContainer: HTMLElement) => {
  avalContainer?.addEventListener('click', (e) => {
    const target = e.target as HTMLElement;

    if (target !== this && target.classList.contains('get-selected-element')) {
      const { id, name } = target.dataset;
      const data = [{ id, name }] as IAccessList[];

      displayLinkedPartnerCustomer(resultsContainer, data);
      target.parentElement?.remove();
    }
  });
}